const menu = {
  label: '• Complexidade',
  to: '/sol/complexidade',
  rules: ['SOL-001'],
}

export default menu;